import classNames from 'classnames';

import type { FCC } from '../../types/common';

import styles from './page_scrollable_content.module.css';

type Props = {
  horizontalScroll?: boolean;
};

const PageScrollableContent: FCC<Props> = ({ children, horizontalScroll }) => (
  <div
    className={classNames(styles.root, {
      [styles.horizontal_scroll]: horizontalScroll,
    })}
  >
    {children}
  </div>
);

export default PageScrollableContent;
